import { createReducer, on, Action } from '@ngrx/store';
import { SelectItem } from 'primeng/api';
import { approveFormSubmission, approveFormSubmissionFailure, approveFormSubmissionSuccess, awardReferralBonus, awardReferralBonusFail, awardReferralBonusSuccess, closeEditEmployeeReferral, deleteEmployeeReferral, deleteEmployeeReferralFail, deleteEmployeeReferralSuccess, deleteReferralBonus, deleteReferralBonusFail, deleteReferralBonusSuccess, getEmployeeReferral, getEmployeeReferralFailure, getEmployeeReferralList, getEmployeeReferralListSuccess, getEmployeeReferralSuccess, getFormApprovalCountSuccess, getFormApprovalQueue, getFormApprovalQueueSuccess, getMyReferrals, getMyReferralsSuccess, getUploadDocApprovalCountSuccess, loadFormApprovalFormListSuccess, recalculateReferralBonus, recalculateReferralBonusFail, recalculateReferralBonusSuccess, rejectEmployeeReferral, rejectEmployeeReferralFail, rejectEmployeeReferralSuccess, resetEmployeeReferral, resetEmployeeReferralFail, resetEmployeeReferralSuccess, saveEmployeeReferral, saveEmployeeReferralFailure, saveEmployeeReferralSuccess, showEditEmployeeReferral, toggleArchiveEmployeeReferral, toggleArchiveEmployeeReferralFail, toggleArchiveEmployeeReferralSuccess, createReferralFormSubmission, createReferralFormSubmissionFail, createReferralFormSubmissionSuccess } from './queues.action'; import { PagingResultsModel } from '../../../models/pagingResultsModel';
import { FormApprovalQueueModel } from '../../../models/queueModels';
import { EmployeeReferralModel, EmployeeReferralQueueModel, MyEmployeeReferralModel } from '../../../models/employeeReferralModel';
import { ProspectiveCandidateModel } from '../../../models/prospectiveCandidateModel';

export interface QueuesState {
  formApprovalFormList: SelectItem[];
  uploadDocApprovalCount: number;
  formApprovalCount: number;

  loadingFormApprovalQueue: boolean;
  formApprovalQueue: PagingResultsModel<FormApprovalQueueModel>;

  editingEmployeeReferral: boolean;
  loadingEmployeeReferral: boolean;
  savingEmployeeReferral: boolean;
  employeeReferralId: number;
  selectedEmployeeReferral: EmployeeReferralModel;
  selectedProspectiveCandidate: ProspectiveCandidateModel;

  employeeReferralList: PagingResultsModel<EmployeeReferralQueueModel>;
  loadingEmployeeReferralList: boolean;
  savingReferralBonus: boolean;

  myReferralList: PagingResultsModel<MyEmployeeReferralModel>;
  loadingMyEmployeeReferralList: boolean;
}

const initialState: QueuesState = {
  formApprovalFormList: [],
  uploadDocApprovalCount: 0,
  formApprovalCount: 0,

  loadingFormApprovalQueue: true,
  formApprovalQueue: null,

  editingEmployeeReferral: false,
  loadingEmployeeReferral: false,
  savingEmployeeReferral: false,
  employeeReferralId: 0,
  selectedEmployeeReferral: null,
  selectedProspectiveCandidate: null,

  employeeReferralList: null,
  loadingEmployeeReferralList: true,
  savingReferralBonus: false,

  myReferralList: null,
  loadingMyEmployeeReferralList: true
};

export const queuesReducer = createReducer(initialState,
  on(loadFormApprovalFormListSuccess, (state, action) => {
    return {
      ...state,
      formApprovalFormList: action.formList,
    };
  }),
  on(getFormApprovalQueue, (state, action) => {
    return {
      ...state,
      loadingFormApprovalQueue: true
    };
  }),
  on(getFormApprovalQueueSuccess, (state, action) => {
    return {
      ...state,
      loadingFormApprovalQueue: false,
      formApprovalQueue: action.list
    };
  }),
  on(approveFormSubmission, (state, action) => {
    return {
      ...state,
      loadingFormApprovalQueue: true
    };
  }),
  on(approveFormSubmissionSuccess, (state, action) => {
    return {
      ...state,
      loadingFormApprovalQueue: false,
    };
  }),
  on(approveFormSubmissionFailure, (state, action) => {
    return {
      ...state,
      loadingFormApprovalQueue: false,
    };
  }),
  on(getUploadDocApprovalCountSuccess, (state, action) => {
    return {
      ...state,      
      uploadDocApprovalCount: action.count
    };
  }),
  on(getFormApprovalCountSuccess, (state, action) => {
    return {
      ...state,
      formApprovalCount: action.count
    };
  }),
  on(showEditEmployeeReferral, (state, action) => {
    return {
      ...state,
      employeeReferralId: action.referralId,
      selectedProspectiveCandidate: action.prospectiveCandidate,
      editingEmployeeReferral: true
    }
  }),
  on(closeEditEmployeeReferral, (state, action) => {
    return {
      ...state,
      employeeReferralId: 0,
      selectedEmployeeReferral: null,
      selectedProspectiveCandidate: null,
      editingEmployeeReferral: false
    }
  }),
  on(getEmployeeReferral, (state, action) => {
    return {
      ...state,
      loadingEmployeeReferral: true
    }
  }),
  on(getEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      selectedEmployeeReferral: action.referral,
      loadingEmployeeReferral: false
    }
  }),
  on(getEmployeeReferralFailure, (state, action) => {
    return {
      ...state,
      loadingEmployeeReferral: false
    }
  }),
  on(saveEmployeeReferral, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: true
    }
  }),
  on(saveEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: false
    }
  }),
  on(saveEmployeeReferralFailure, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: false
    }
  }),
  on(getMyReferrals, (state, action) => {
    return {
      ...state,
      loadingMyEmployeeReferralList: true
    };
  }),
  on(getMyReferralsSuccess, (state, action) => {
    return {
      ...state,
      loadingMyEmployeeReferralList: false,
      myReferralList: action.referralList
    };
  }),
  on(getEmployeeReferralList, (state, action) => {
    return {
      ...state,
      loadingEmployeeReferralList: true
    };
  }),
  on(getEmployeeReferralListSuccess, (state, action) => {
    return {
      ...state,
      loadingEmployeeReferralList: false,
      employeeReferralList: action.referralList
    };
  }),
  on(awardReferralBonus, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(awardReferralBonusSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(awardReferralBonusFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(createReferralFormSubmission, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: true
    };
  }),
  on(createReferralFormSubmissionSuccess, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: false
    };
  }),
  on(createReferralFormSubmissionFail, (state, action) => {
    return {
      ...state,
      savingEmployeeReferral: false
    };
  }),
  on(recalculateReferralBonus, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(recalculateReferralBonusSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(recalculateReferralBonusFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(deleteReferralBonus, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(deleteReferralBonusSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(deleteReferralBonusFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(toggleArchiveEmployeeReferral, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(toggleArchiveEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(toggleArchiveEmployeeReferralFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(rejectEmployeeReferral, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(rejectEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(rejectEmployeeReferralFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(resetEmployeeReferral, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(resetEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(resetEmployeeReferralFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(deleteEmployeeReferral, (state, action) => {
    return {
      ...state,
      savingReferralBonus: true
    };
  }),
  on(deleteEmployeeReferralSuccess, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
  on(deleteEmployeeReferralFail, (state, action) => {
    return {
      ...state,
      savingReferralBonus: false
    };
  }),
)

export function queuesReducerFunc(state: QueuesState | undefined, action: Action) {
  return queuesReducer(state, action);
}
